import { HelpCircle, FileText, TicketPlus, PlayCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";

const ONBOARDING_KEY_PREFIX = "qsg_onboarding_completed";

export function HelpMenu() {
  const navigate = useNavigate();

  const handleRestartTour = async () => {
    // Clear the user-specific onboarding key
    const { data: { session } } = await supabase.auth.getSession();
    if (session?.user) {
      localStorage.removeItem(`${ONBOARDING_KEY_PREFIX}_${session.user.id}`);
    }
    // Also clear any legacy key without user ID
    localStorage.removeItem(ONBOARDING_KEY_PREFIX);
    navigate("/dashboard");
    window.location.reload();
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="relative">
          <HelpCircle className="h-5 w-5" />
          <span className="sr-only">Help menu</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48 bg-popover z-50">
        <DropdownMenuItem
          onClick={() => navigate("/support")}
          className="cursor-pointer"
        >
          <FileText className="mr-2 h-4 w-4" />
          Support Docs
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => navigate("/support-tickets")}
          className="cursor-pointer"
        >
          <TicketPlus className="mr-2 h-4 w-4" />
          Submit a Ticket
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={handleRestartTour}
          className="cursor-pointer"
        >
          <PlayCircle className="mr-2 h-4 w-4" />
          Restart Tour
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
